import { Grid, Paper, TableFooter, TablePagination, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme, withStyles
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Button from '@mui/material/Button';
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { generateGenomicsResearchUrl } from "../../../../helpers/generateUrl";
import TicketCommentsModal from "../Billings/comment";
import { MessageRounded } from "@material-ui/icons";
import {
    FetchFinalReport, getProjects
} from "../../store/actions";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },
        tableContainer: {
            marginTop: "2rem",
            position: "sticky",
            top: "200px",
        },
        input: {
            padding: "1px",
        },
        text: { color: "black" },
    })
);
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);


interface Props {
    getProjects: any;
    projects: any;
    FetchFinalReport: any;
    fetchFinalReportData: any;

}
const StopsPlace: React.FC<Props> = ({
    getProjects,
    projects,
    FetchFinalReport,
    fetchFinalReportData,

}) => {
    const history = useHistory();
    const timer = useRef<any>(0);
    const classes = useStyles();
    const [projectId, setProjectId] = useState<any>("");
    const [project, setProject] = useState<any>(null);
    const [page, setPage] = useState(0);
    const [displayProject, setDisplayProject] = useState<string>("");
    const [openModal, setopenModal] = useState<boolean>(false);
    const [runData, setRunData] = useState<any>("")

    useEffect(() => {
        FetchFinalReport();
    }, [])

    const filterBillingData = (e: any) => {
        const body: any = {
            projectId: project,
        };
        const url = generateGenomicsResearchUrl(body).substring(2);
        FetchFinalReport(`${url}`);
        setPage(0);
    };
    const handleChangePage = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        newPage: number
    ) => {
        if (newPage > page) {
            let url = projects.links && projects.links.next.split("?")[1];
            FetchFinalReport(`?${url}`);
        } else if (newPage < page) {
            let url = projects.links && projects.links.previous.split("?")[1];
            FetchFinalReport(`${url === undefined ? "" : "?" + url}`);
        }
        setPage(newPage);
    };
    const handleClick = (data: any) => {
        setopenModal(true);
        setRunData(data);
    };

    return (
        <form style={{ width: "100%", marginLeft: 14 }} onSubmit={filterBillingData}>
            <Grid container spacing={2} style={{ marginTop: 80 }}>
                <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Billings & Project Closed DashBoard </h2>
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    style={{ marginTop: 10 }}
                >
                    <Grid item xs={12} sm={6} md={5}>
                        <Autocomplete
                            id="Project_id"
                            onChange={(event, newValue) => {
                                setProject(newValue?.projectId);
                            }}
                            options={projects?.results || []}
                            blurOnSelect
                            getOptionLabel={(option: any) => {
                                return (
                                    (option?.projectId) +
                                    " " +
                                    (option?.institute?.name || "") +
                                    " " +
                                    (option?.scientist?.name || "") +
                                    "," +
                                    (option?.dealer?.firmName || "")
                                );
                            }}
                            onInputChange={(event, newInputValue) => {
                                let data = newInputValue.split(" ");
                                clearTimeout(timer.current);
                                timer.current = setTimeout(() => {
                                    if (data.length > 0) {
                                        getProjects(`?projectId=${data[0]}`);
                                    }
                                }, 1000);
                                setDisplayProject(newInputValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className="input"
                                    label="Project Id"
                                    placeholder="Search ID/Client/Dealer Name"
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <Button
                            variant="contained"
                            color="secondary"
                            fullWidth
                            onClick={filterBillingData}
                        >
                            Filter
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <Button
                            variant="contained"
                            color="primary"
                            fullWidth
                            onClick={() => history.go("/dashboard/gnrelab/ProjectCloser")}
                        >
                            Reset
                        </Button>
                    </Grid>
                </Grid>
                <Grid container style={{ marginTop: 10 }}>
                    <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "540px" }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="center">
                                        Project ID
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        No Of Samples
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        No Of Library
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        Billing Status
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        Comment
                                    </StyledTableCell>
                                    {/* <StyledTableCell align="center">
                                    Download Closer Form1
                                </StyledTableCell> */}
                                    <StyledTableCell align="center">
                                        Download Closer Form
                                    </StyledTableCell>
                                    <StyledTableCell align="center">
                                        Close Projects
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            {/* dummy data  */}
                            <TableBody>
                                {fetchFinalReportData && fetchFinalReportData?.results && fetchFinalReportData?.results?.length > 0 && fetchFinalReportData?.results?.map((data: any, index: any) => {
                                    return (
                                        <StyledTableRow >
                                            <StyledTableCell align="center">
                                                {data?.projectId}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.sampleRegisteredCount}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.librariesCount}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.phase === "Closed" ? "Project Closed" : "Not Closed"}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.deliverable?.comment === "" || data?.deliverable?.comment === undefined ?
                                                    ""
                                                    : <div>
                                                        <MessageRounded
                                                            onClick={() => handleClick(data)}
                                                        />
                                                    </div>}
                                            </StyledTableCell>
                                            {/* <StyledTableCell align="center">
                                            <Button
                                                color="primary"
                                                variant="contained"
                                                onClick={() =>
                                                    history.push(
                                                        `/dashboard/gnrelab/projectCloser/form/${data?._id}`
                                                    )
                                                }
                                            >
                                                <CloudDownloadIcon />
                                            </Button>
                                        </StyledTableCell> */}
                                            <StyledTableCell align="center">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={() =>
                                                        history.push(
                                                            `/dashboard/gnrelab/projectCloser/form1/${data?._id}`
                                                        )
                                                    }
                                                >
                                                    <CloudDownloadIcon />
                                                </Button>
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disabled={data?.phase === "Closed"}
                                                    onClick={() =>
                                                        history.push(`/dashboard/gnrelab/ProjectCloser/new/${data?._id}`)
                                                    }
                                                >
                                                    <SaveAsIcon />
                                                </Button>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                            <TableFooter>
                                <TablePagination
                                    rowsPerPageOptions={[]}
                                    colSpan={3}
                                    count={fetchFinalReportData?.count || 0}
                                    rowsPerPage={fetchFinalReportData?.page_size}
                                    page={page}
                                    onPageChange={handleChangePage}
                                />
                            </TableFooter>
                        </Table>
                    </TableContainer>
                    <TicketCommentsModal
                        openModal={openModal}
                        setopenModal={setopenModal}
                        rundata={runData}
                    />
                </Grid>
            </Grid>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    fetchFinalReportData: state.GenomicsLabReducer.fetchFinalReportData,
});
export default connect(mapStateToProps, {
    getProjects,
    FetchFinalReport,
})(StopsPlace);
